
  import { computed, defineComponent, onMounted, ref } from 'vue';

  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Tabs from '@/components/tabs.vue';
  import IreUnitCompValuesRecords from '@/components/ire/IreUnitCompValues.vue';

  export default defineComponent({
    name: 'ire-investment-sizes-values',
    components: {
      Tabs,
      IreUnitCompValuesRecords,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();
      const selectIreArea = ref<number>(0);
      const loading = ref(false);
      const selectedPermissions = ref([]);

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('Unit Components List'), [
          translate('ire'),
        ]);
      });
      await store.dispatch(Actions.GET_All_IRE_UNIT_COMP);

      // const changeArea = async (id) => {
      //   loading.value = true;
      //   await store.dispatch(Actions.GET_All_IRE_V2_SIZE_DESC, id);
      //   loading.value = false;
      // };

      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmitUpdate = async (values) => {
        console.log(values);
        loading.value = true;
        const payload = {
          updateIreUnitCompDtoValues: values,
        };
        await store.dispatch(Actions.UPDATE_IRE_UNIT_COMP, payload);
        // let sizeDescOptions = store.getters.ireV2SizeDesc;

        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];
        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
        } else {
          loading.value = false;
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            selectIreArea.value = 0;
            router.push({ name: 'ire-investment-areas-listing' });
          });
        }
      };

      const tableHeader = ref([
        {
          name: translate('size'),
          key: 'size',
          sortable: true,
        },
        {
          name: translate('rooms'),
          key: 'rooms',
          sortable: true,
        },
        {
          name: translate('bathrooms'),
          key: 'bathrooms',
          sortable: true,
        },
        {
          name: translate('decreasedRooms'),
          key: 'decreasedRooms',
          sortable: true,
        },
        {
          name: translate('decreasedBathrooms'),
          key: 'decreasedBathrooms',
          sortable: true,
        },
        {
          name: translate('decreasedMaidRoom'),
          key: 'decreasedMaidRoom',
          sortable: true,
        },
        {
          name: translate('increasedRooms'),
          key: 'increasedRooms',
          sortable: true,
        },
        {
          name: translate('increasedBathrooms'),
          key: 'increasedBathrooms',
          sortable: true,
        },
        {
          name: translate('increasedMaidRoom'),
          key: 'increasedMaidRoom',
          sortable: true,
        },
        {
          name: '',
          key: 'actions',
          sortable: true,
        },
      ]);

      const updateIreSizeValuesList = (list) => {
        selectedPermissions.value = list;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.ireUnitComp),

        onSubmitUpdate,
        translate,
        can,
        selectIreArea,
        tableHeader,
        loading,
        updateIreSizeValuesList,
      };
    },
  });
